import React from 'react';
import OldValuesHeader from './OldValuesHeader';
import { humanize, additionalTestFieldIndex } from '../../../../itrust_common/components/HelperFunctions';

import Default from '../overview/additionalTests/Default'
import AmslerGrid from '../overview/additionalTests/AmslerGrid'
import PunctalPlug from '../overview/additionalTests/PunctalPlug'
import Epilation from '../overview/additionalTests/Epilation'
import ForeignBodyRemoval from '../overview/additionalTests/ForeignBodyRemoval'
import SkinTagRemovel from '../overview/additionalTests/SkinTagRemovel'
import AmnioticMembrane from '../overview/additionalTests/AmnioticMembrane'
import Pachymetry from '../overview/additionalTests/Pachymetry'
import InflammaDry from '../overview/additionalTests/InflammaDry'
import TearLab from '../overview/additionalTests/TearLab'

const renderTest = (fieldsValue, template, defaultLabel, isExpandedGrid) => {
  switch (defaultLabel) {
    case 'Amsler grid':
      return <AmslerGrid fieldsValues={fieldsValue} template={template} />
    case 'Punctal plug':
      return <PunctalPlug fieldsValues={fieldsValue} template={template} />
    case 'Epilation':
      return <Epilation fieldsValues={fieldsValue} template={template} />
    case 'Foreign body removal':
      return <ForeignBodyRemoval fieldsValues={fieldsValue} template={template} />
    case 'Skin tag removal':
      return <SkinTagRemovel fieldsValues={fieldsValue} template={template} />
    case 'Amniotic membrane':
      return <AmnioticMembrane fieldsValues={fieldsValue} template={template} />
    case 'Pachymetry':
      return <Pachymetry fieldsValues={fieldsValue} template={template} />
    case 'Inflamma dry':
      return <InflammaDry fieldsValues={fieldsValue} template={template} />
    case 'Tear lab':
      return <TearLab fieldsValues={fieldsValue} template={template} />
    default:
      return <Default fieldsValues={fieldsValue} template={template} isExpandedGrid={isExpandedGrid} />
  }
}

const getOverviewId = (overviewName) => (
  typeof overviewName === 'string' ? overviewName : overviewName?.id
)

const getTestTemplate = (overviewName, template) => {
  const overviewId = getOverviewId(overviewName)
  const index = additionalTestFieldIndex(overviewId)
  if (template?.tests?.[index]) return template.tests[index]

  return template?.tests?.find(test => test.default_label === humanize(overviewId))
}

const AdditionalTests = props => {
  const { fieldsValues, template, overviewName, examId, isExpandedGrid } = props;
  const testTemplate = getTestTemplate(overviewName, template)

  if (!testTemplate) return null

  return (
    <>
      {(fieldsValues || []).filter(prevExam => prevExam.id !== examId).map(prevExam => {
        const testIndex = template.tests.indexOf(testTemplate)
        const member = prevExam.additional_tests_attributes?.[testIndex]

        if (!member?.is_marked_complete) return null

        return (
          <div className="col-12 border rounded mb-4 px-0" key={prevExam.id}>
            <div className="row mx-0">
              <OldValuesHeader
                prevExam={prevExam}
                overviewName={typeof overviewName === 'string' ? { id: overviewName } : overviewName}
                examId={examId}
              />
              <div className="col-12 py-4">
                {renderTest(member, testTemplate.fields, testTemplate.default_label, isExpandedGrid)}
              </div>
            </div>
          </div>
        )
      })}
    </>
  )
}

export default AdditionalTests;
